import styles from './HomeSectionOffer.module.scss';
import React, { useState } from 'react';
import Modal from '../Modal';
import Logo from '../Logo';
import { Facebook } from "../OIDC";

// The fb1 landing page uses this with props.facebook.
// That removes the 20% 
const HomeSectionOffer = (props) => {
  const [show, setShow] = useState(false);
  const onOpen = () => {
    setShow(true);
  };
  const onClose = () => {
    setShow(false);
  };

  return (
    <>
      <div className={styles.logoContainer}>
        <Logo />
      </div>
      <section id="home-section" className={styles.homeContainer}>
        <div className="bgvid" id="bgvid">
          <video disableRemotePlayback autoPlay muted loop preload="auto">
            <source className="home-vid-src" src="/img/av-home-main-r8.webm" type="video/webm" />
            <source className="home-vid-src" src="/img/av-home-main-r8.mp4" type="video/mp4" />
          </video>
        </div>
        <h1 className="zup">Entertain your guests with a live photo stream while creating an album of candid photos</h1>
        <h1 className="zup offer-h1" style={{ fontWeight: 900, color: '#02c3d9' }}>
          {props.facebook || "Now 20% OFF!" }
        </h1>
        <p className="zup">
          Collect forgotten old photos from friends and family before your event, then stream them at your event along with new photos shared by guests in real-time!
          <span className="just-text">
            No app. <i>Just texting.</i>
          </span>
        </p>

        <div className={styles.wrap}>
			{props.facebook ? <Facebook /> : (
			  <div onClick={onOpen} className="video open-modal zup" data-content-type="video" data-content="img/av-main-20sec">
				Watch
				<span>
				  <div></div>
				</span>
			  </div>
			)}
        </div>
        <div className="bottom-wave"></div>

        <Modal show={show} onClose={onClose}>
          <video disableRemotePlayback className="media" autoPlay controls>
            <source src="/img/av-main-20sec.webm" type="video/webm" />
            <source src="/img/av-main-20sec.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Modal>
      </section>
    </>
  );
};

export default HomeSectionOffer;
